/* unplugin-vue-components disabled */import script from "./setScoreDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./setScoreDialog.vue?vue&type=script&setup=true&lang=js"

import "./setScoreDialog.vue?vue&type=style&index=0&id=66555a89&lang=scss"
import "./setScoreDialog.vue?vue&type=style&index=1&id=66555a89&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66555a89"]])

export default __exports__